var path = '/mnt/data/www/mashservisnn/vhost/frontend/src/app/modules/reviews/reviews.html';
var html = "<div style=text-align:center> <ng-youtube-embed ng-repeat=\"review in ctrl.reviews\" video=review.url autoplay=false color=white disablekb=true> </ng-youtube-embed> <div class=row style=margin-top:10px> <div ng-repeat=\"review in ctrl.reviews\" ng-click=ctrl.select(review) style=cursor:pointer;padding:10px class=\"col-xs-4 col-sm-4 col-md-3 col-lg-2\"> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/reviews/reviews.html
// module id = 71
// module chunks = 0